document.addEventListener("DOMContentLoaded", function () {

  // ── Swiper initialisation ──────────────────────────────────────────────
  document.querySelectorAll(".index-main-slider").forEach((slider) => {

    const autoplayEnabled = slider.dataset.autoplay === "true";
    const paginationEnabled = slider.dataset.pagination === "true";
    const arrowsEnabled = slider.dataset.arrows === "true";

    new Swiper(slider, {
      loop: true,
      speed: 800,
      slidesPerView: 1,

      autoplay: autoplayEnabled ? {
        delay: 5000,
        disableOnInteraction: false
      } : false,

      pagination: paginationEnabled ? {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      } : false,

      navigation: arrowsEnabled ? {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev")
      } : false

    });

  });

  // ── Section height recalculation ──────────────────────────────────────
  function updateSectionHeight() {
    const sections = document.querySelectorAll(".index_main_background_image");

    sections.forEach(section => {
      const contentWrapper = section.querySelector(".slider-content-wrapper");

      if (contentWrapper) {
        const contentHeight = contentWrapper.scrollHeight;
        section.style.height = contentHeight + "px";
      }
    });
  }

  // Debounced resize handler — prevents layout thrashing on every pixel
  let resizeTimer;
  function debouncedResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSectionHeight, 150);
  }

  // Initial call on page load
  updateSectionHeight();

  // Recalculate on window resize (debounced)
  window.addEventListener("resize", debouncedResize);

});
